import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as constants from '../app/shared/globalcontants';
import { LocalTranslationService } from './core/services/local-translate.service';
import { TranslateService } from '@ngx-translate/core';
import { AppSettingModel } from './msal-module/azure-ad.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private settings: any;
  private http: HttpClient;

  constructor(private readonly httpHandler: HttpBackend, private translate: TranslateService) {
    this.http = new HttpClient(httpHandler);
  }

  init(endpoint: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      localStorage.setItem('RequisitionRequired', 'False');
      localStorage.setItem('EnableClassCalendarIntegration', 'False');
      this.http.get(endpoint).subscribe(async (value: AppSettingModel) => {
            this.settings = value;
            const TenantLanguageCode = ( value?.DefaultLanguageCode ) ? value?.DefaultLanguageCode : constants.DefaultLanguage;
            const TenantIdendifier = ( value?.TenantIdentifier ) ? value?.TenantIdentifier : localStorage.getItem('tenant');
            const TenantlanguageMasters = ( value?.LanguageMasters ) ? JSON.parse(value?.LanguageMasters) : [];
            if (TenantlanguageMasters.length && TenantlanguageMasters.length > 0) {
              TenantlanguageMasters?.map((el)=>{
                el.id = el.languageCode
                el.value = el.languageName
                return el
              })
            }
            localStorage.setItem('availableLanguage', JSON.stringify(TenantlanguageMasters));
            localStorage.setItem('editionId', value?.EditionId);
            localStorage.setItem('RequisitionRequired', value?.RequisitionRequired);
            localStorage.setItem('EnableClassCalendarIntegration', value?.EnableClassCalendarIntegration);
            localStorage.setItem('EnableRecipeExtendedCosts', value?.EnableRecipeExtendedCosts);
            localStorage.setItem('ShowTransferAcknowledgement', value?.ShowTransferAcknowledgement);
            localStorage.setItem('aiFeatureConfiguration', value?.aiFeatureConfiguration);            
            localStorage.setItem('isOnPrem', value?.IsOnPrem?.toString());
            let params= {
                "UserId": 0,
                "LanguageCode": TenantLanguageCode,
                "Version": null,
                "Group": "Mobile"
            }
            const httpOptions = {
              headers: new HttpHeaders(
                {
                  'tenant': TenantIdendifier
                })
          };
              const EnpointUrl = value['Api_Url'];
              const systemConfigPayload = ['AzureAD','Webclient'];
               this.http.post(EnpointUrl + constants.apiURLs.UserManagementApi.GetSystemConfig,
                systemConfigPayload, httpOptions).subscribe((configs: any)=> {
                  this.settings['SystemConfig'] = configs;
                  const langEndPoint="/usermgmt/api/Login/GetLanguage";
                  this.http.post(EnpointUrl + langEndPoint, params, httpOptions).subscribe(x=> {
                    const languageCode = x?.['LanguageCode'];
                    localStorage.setItem(constants.LanguageJson, x['LanguageFile']);
                    localStorage.setItem(constants.CurrentVersion, null);
                    localStorage.setItem(constants.SelectedLanguage, x['LanguageCode'])
                    this.translate.use(languageCode);
                      resolve(true);
                  },(error) => {
                    const defaultLanJson = 'assets/i18n/en-US.json'
                    this.http.get(defaultLanJson).subscribe(defaultLanguage=> {
                      localStorage.setItem(constants.LanguageJson, JSON.stringify(defaultLanguage));
                      localStorage.setItem(constants.SelectedLanguage, constants.DefaultLanguage);
                      localStorage.setItem(constants.CurrentVersion, null);
                      this.translate.use(constants.DefaultLanguage);
                      resolve(true);
                    }, (error)=> {
                      resolve(true);
                    })
                  });
                }, (error)=> {
                  const defaultLanJson = 'assets/i18n/en-US.json'
                    this.http.get(defaultLanJson).subscribe(defaultLanguage=> {
                      localStorage.setItem(constants.LanguageJson, JSON.stringify(defaultLanguage));
                      localStorage.setItem(constants.SelectedLanguage, constants.DefaultLanguage);
                      localStorage.setItem(constants.CurrentVersion, null);
                      this.translate.use(constants.DefaultLanguage);
                      resolve(true);
                    }, (error)=> {
                      resolve(true);
                    })

                  resolve(true);
                })


        },
        (error) => {
          reject(error);
        });
    });
  }

  getSettings(key?: string | Array<string>): any {
    if (!key || (Array.isArray(key) && !key[0])) {
      return this.settings;
    }

    if (!Array.isArray(key)) {
      key = key.split('.');
    }

    let result = key.reduce((account: any, current: string) => account && account[current], this.settings);

    return result;
  }
}